import React from "react";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Instagram,
  Facebook,
  MessageSquare,
} from "lucide-react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Get in Touch</h1>
          <p className="contact-hero-subtitle">We'd Love to Hear From You</p>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="contact-intro">
            <h2 className="contact-intro-title">Visit Our Shop</h2>
            <p className="contact-intro-text">
              Schedule an appointment to discuss your custom tailoring needs,
              explore fabric options, and experience personalized service. We
              look forward to creating something beautiful for you.
            </p>
          </div>

          <div className="contact-details-grid">
            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <Phone size={28} />
              </div>
              <h3 className="contact-detail-title">Call Us</h3>
              <a href="tel:+919585693060" className="contact-detail-value">
                +91 95856 93060
              </a>
              <p className="contact-detail-note">
                Available during business hours
              </p>
            </div>

            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <MapPin size={28} />
              </div>
              <h3 className="contact-detail-title">Shop Location</h3>
              <p className="contact-detail-value">
                10A, kaveri street, vembu avanu, Vadavelli
              </p>
              <p className="contact-detail-note">
                Coimbatore - 641041, Tamil Nadu, India
              </p>
            </div>

            <div className="contact-detail-card">
              <div className="contact-detail-icon">
                <Clock size={28} />
              </div>
              <h3 className="contact-detail-title">Business Hours</h3>
              <p className="contact-detail-value">Monday - Saturday</p>
              <p className="contact-detail-note">9:00 AM - 8:00 PM</p>
              <p className="contact-detail-note">Sunday: By Appointment</p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-map-section">
        <div className="contact-map-container">
          <h2 className="contact-map-title">Find Us</h2>
          <div className="contact-map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d250646.38686655866!2d76.81199717109385!3d11.016844599999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af2f971cb5%3A0x2fc1c81e183ed282!2sCoimbatore%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="PSD Designers Location"
            ></iframe>
          </div>
          <p className="contact-map-note">
            Note: Update the map coordinates with your exact shop address for
            precise location
          </p>
        </div>
      </section>

      <section className="contact-social-section">
        <div className="contact-social-container">
          <h2 className="contact-social-title">Connect With Us</h2>
          <p className="contact-social-subtitle">
            Follow us on social media for latest designs, trends, and
            behind-the-scenes content
          </p>

          <div className="contact-social-links">
            <a
              href="https://www.instagram.com/senbagampalanisamy561?utm_source=qr&igsh=dmZ3cnlnNmk3eGl2"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-social-link"
            >
              <Instagram size={32} />
              <span>Follow on Instagram</span>
            </a>
          </div>
        </div>
      </section>

      <section className="contact-cta-section">
        <div className="contact-cta-container">
          <h2 className="contact-cta-title">
            Ready to Create Your Perfect Outfit?
          </h2>
          <p className="contact-cta-text">
            Book your consultation today and let us bring your fashion vision to
            life
          </p>
          <a href="tel:+919585693060" className="contact-cta-button">
            Book a Fitting Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
